import { Button, SVGIcon } from '@asset-metrix/portal-ui';
import { useDisclosure } from '@mantine/hooks';

import { ZipUploadModal } from './ZipUploadModal';

export type ZipUploadModalProps = {
  onClose: () => void;
  opened: boolean;
  withinPortal?: boolean;
};

export function ZipUploadButton() {
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <>
      <Button
        icon={<SVGIcon name="upload-zip" />}
        variant="secondary"
        onClick={open}
      />
      <ZipUploadModal onClose={close} opened={opened} />
    </>
  );
}
